require('./dist/angular-gettext.js');
module.exports = 'gettext';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-gettext/index.js
// module id = 236
// module chunks = 6